// Define MarginType enum
export enum MarginType {
  CASH = 'cash',
  ISOLATED = 'isolated',
  // CROSS = 'cross',
}
